import { NavLink, Outlet } from "react-router-dom";
import "./dashboard.css";

// v2 "Living Cast" dashboard chrome — sticky sidebar, branded mark, v2 LIVE pill,
// active route highlight. Mobile collapses to a single column under 900px (see
// dashboard.css).

interface DashLink {
  to: string;
  label: string;
  glyph: string;
  end?: boolean;
}

const LINKS: DashLink[] = [
  { to: "/dashboard",            label: "Home",      glyph: "◇", end: true },
  { to: "/dashboard/setup",      label: "Setup",     glyph: "◈" },
  { to: "/dashboard/overlay",    label: "Overlay",   glyph: "▣" },
  { to: "/dashboard/donations",  label: "Donations", glyph: "❖" },
  { to: "/dashboard/factions",   label: "Factions",  glyph: "▲" },
  { to: "/dashboard/analytics",  label: "Analytics", glyph: "≋" },
  { to: "/dashboard/settings",   label: "Settings",  glyph: "⚙" },
];

export default function DashboardLayout(): JSX.Element {
  return (
    <div className="dash">
      <aside className="dash-side">
        <div className="dash-brand">
          <div className="dash-brand-mark">T</div>
          <div className="dash-brand-text">Studio</div>
          <span className="dash-v2-pill">
            <span className="dash-v2-dot" /> v2 LIVE
          </span>
        </div>
        <nav className="dash-nav">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              className={({ isActive }) =>
                `dash-link${isActive ? " active" : ""}`
              }
            >
              <span className="dash-link-glyph">{l.glyph}</span>
              <span>{l.label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="dash-side-foot">Living Cast · 0.2</div>
      </aside>
      <section className="dash-main">
        <Outlet />
      </section>
    </div>
  );
}
